export const canChangeRate = (
  defaultRate: number,
  newRate: number,
  rateChangeThresholdPct: number
) => {
  const rateDiff = Math.floor((rateChangeThresholdPct / 100) * defaultRate);

  return newRate <= defaultRate + rateDiff && newRate >= defaultRate - rateDiff;
};

export const getMinMaxRateChange = (
  defaultRate: number,
  rateChangeThresholdPct: number
) => {
  const rateDiff = Math.floor((rateChangeThresholdPct / 100) * defaultRate);

  return {
    min: defaultRate - rateDiff,
    max: defaultRate + rateDiff,
    canChangeRate: rateChangeThresholdPct > 0,
  };
};
